import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ContentTemplate, PageLayout } from '../../common/components/layout';
import Menu from './Menu';
import APICaller from '../../../library/APICaller';

import { api, service } from '../config';
import { fetch } from '../../../redux/actions';
import ContentList from './ContentList';
import Paging from '../../common/components/Paging';
import {
  decodeURIComponentPlus,
  generateQuery,
  getPageName,
} from '../../../utils/miscUtils';

const mapStateToProps = ({ fetch, MemberReducer }) => {
  return {
    categoryOptions: fetch?.multipleList?.referenceRoomCategory ?? [],
    list: fetch?.multipleList?.referenceRoomList?.results ?? [],
    studentInfo: MemberReducer.studentInfo,
    actor: MemberReducer.actor,
  };
};

const mapDispatchToProps = (dispatch) => ({
  multipleList: (list) => dispatch(fetch.multipleList(list)),
  getList: (url, params) => dispatch(fetch.list(url, params)),
});

class ReferenceRoom extends Component {
  constructor(props) {
    super(props);

    this.state = {
      category: {
        name: this.props.category,
        data: this.props.category === '전체' ? '' : this.props.category,
      },
    };
  }

  async componentDidMount() {
    await this.fetch();
    await this.setScroll();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.subject !== prevProps.subject) {
      this.setState({
        category: { name: '전체', data: '' },
      });
    }
  }

  async fetch() {
    await this.getBoardInfo();
    await this.getBoardList();
  }

  async getBoardInfo() {
    try {
      const boardInfoApiObj = api.getBoard();
      const boardInfo = await APICaller.get(
        boardInfoApiObj.url,
        boardInfoApiObj.params
      );

      const postCategoryTagId = boardInfo?.data?.post_category_tag;
      const boardId = boardInfo?.data?.id;

      if (postCategoryTagId) {
        this.boardId = boardId;
        await this.props.multipleList([
          {
            id: 'referenceRoomCategory',
            ...api.getBoardCategory(postCategoryTagId),
          },
        ]);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getBoardList() {
    await this.props.multipleList([
      { id: 'referenceRoomList', ...api.getBoardList(this.boardId) },
    ]);
  }

  setScroll() {
    const pageData = JSON.parse(
      sessionStorage.getItem('referenceRoomPageData')
    );
    const scrollPosition = pageData?.scrollPosition ?? 0;

    if (scrollPosition) {
      if (pageData.result === 'success') {
        window.scroll({
          top: scrollPosition,
          left: 0,
          behavior: 'smooth',
        });
      }
      sessionStorage.removeItem('referenceRoomPageData');
    }
  }

  onSelectCategory(category) {
    const { history } = this.props;
    this.setState({ category: category });
    const pageName = getPageName(history, { noQueries: true });
    const query = {
      ...history.query,
      category: decodeURIComponentPlus(category.name),
    };
    this.props.history.push(`${pageName}${generateQuery(query)}`);
  }

  onChangePage(pageNo) {
    const { history } = this.props;
    const pageName = getPageName(history, { noQueries: true });
    const query = { ...history.query, pageno: pageNo };
    this.props.history.push(`${pageName}${generateQuery(query)}`);
  }

  renderTitle() {
    return (
      <h4>
        <span>학습자료실</span>
      </h4>
    );
  }

  renderDescription() {
    return (
      <div className="description">
        <p>
          윙크 학습자료실은 가정에서 인쇄하여 활용하면 유용할 각종 자료들을
          제공하는 곳입니다.
        </p>
        <p>
          윙크 정회원에게는 실물 자료들이 매월 정기배송을 통해 제공되지만, 일부
          자료에 한해
        </p>
        <p>
          추가 인쇄를 할 수 있도록 제공하오니 가정에서 활용해 보시길 바랍니다.
        </p>
        <p className="danger">
          또한, 무료 회원가입만 해도 제공되는 자료들도 있으니, 꼭 활용해 보세요.
        </p>
        <img
          className="description-bg"
          src="https://us.wink.co.kr/pc/renewalV3/reference_room/bg.png"
          alt=""
        />
      </div>
    );
  }

  renderMenu() {
    const { subject, categoryOptions } = this.props;
    const { category } = this.state;

    return (
      <Menu
        subject={subject}
        category={service.makeCategoryOptions(categoryOptions, subject)}
        onSelectCategory={this.onSelectCategory.bind(this)}
        selected={category}
      />
    );
  }

  renderList() {
    const { subject, list, studentInfo, history, actor, pageno } = this.props;
    const { category } = this.state;

    const renderedList = service.getListForPage(
      service.getFilteredList(list, subject, category),
      pageno
    );

    if (renderedList.length === 0) {
      return (
        <div className="message-box no-data no-line">
          <p>
            <strong>등록된 학습 자료 콘텐츠가 없습니다.</strong>곧 새로운 학습
            자료가 업로드 될 예정입니다.
          </p>
        </div>
      );
    }

    return (
      <ContentList
        list={renderedList}
        student={studentInfo}
        history={history}
        parent={actor}
      />
    );
  }

  renderPaging() {
    const { subject, history, list, pageno } = this.props;
    const { category } = this.state;
    const totalList = service.getFilteredList(list, subject, category);

    return (
      <Paging
        selected={parseInt(pageno, 10)}
        step={5}
        onClick={this.onChangePage.bind(this)}
        count={totalList.length}
        pageSize={10}
      />
    );
  }

  render() {
    return (
      <PageLayout>
        <ContentTemplate>
          <div className="reference-room-container">
            <div className="reference-room-content">
              {this.renderTitle()}
              <div style={{ width: '960px' }}>
                {this.renderDescription()}
                {this.renderMenu()}
                {this.renderList()}
                {this.renderPaging()}
              </div>
            </div>
          </div>
        </ContentTemplate>
      </PageLayout>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReferenceRoom);
